import React from 'react';
import KeywordOptimizationPage from '../Pages/KeywordOptimizationPage';

const KeywordOptimizationRoutes = () => {
  return <KeywordOptimizationPage />;
};

export default KeywordOptimizationRoutes;
